export default "__VITE_ASSET__JPa$spsW__"